var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 40,
    viewBox: "0 0 86 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7145",
    "data-name": "Groupe 7145",
    transform: "translate(-119.597 -170.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "picture",
    transform: "translate(146.775 174.804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9819",
    "data-name": "Trac\\xE9 9819",
    d: "M14.968,12.841a4.041,4.041,0,0,0-5.717,0L.038,22.054a6.723,6.723,0,0,0,6.684,6.228H25.579a6.692,6.692,0,0,0,3.707-1.121Z",
    transform: "translate(0.013 4.045)",
    fill: "#717171"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 3.502,
    cy: 3.502,
    r: 3.502,
    transform: "translate(20.743 5.388)",
    fill: "#717171"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_9820",
    "data-name": "Trac\\xE9 9820",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.592,0H6.735A6.743,6.743,0,0,0,0,6.735V22.341l7.36-7.36a6.735,6.735,0,0,1,9.526,0L31.205,29.3a6.693,6.693,0,0,0,1.122-3.708V6.735A6.743,6.743,0,0,0,25.592,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.737237930297852 1.999996185302734 C 4.128238677978516 2.003116607666016 2.003118515014648 4.128246307373047 1.999998092651367 6.734857559204102 L 1.999998092651367 17.51243209838867 L 5.94544792175293 13.56697654724121 C 7.595329284667969 11.91665649414062 9.789138793945312 11.00778579711914 12.12273788452148 11.00778579711914 C 14.45633888244629 11.00778579711914 16.65013885498047 11.91665649414062 18.29982757568359 13.56679630279541 L 30.32729721069336 25.59426498413086 C 30.32729721069336 25.59364318847656 30.32729911804199 25.59305953979492 30.32729911804199 25.59243774414062 L 30.32729911804199 6.73725700378418 C 30.32416915893555 4.128246307373047 28.19904899597168 2.00312614440918 25.59243774414062 1.999996185302734 L 6.737237930297852 1.999996185302734 M 6.734848022460938 -3.814697265625e-06 L 25.59243774414062 -3.814697265625e-06 C 29.31014823913574 0.004457473754882812 32.32283782958984 3.017147064208984 32.32729721069336 6.734857559204102 L 32.32729721069336 25.59243774414062 C 32.32703018188477 26.91209602355957 31.93666839599609 28.20221710205078 31.20526885986328 29.30065727233887 L 16.88561820983887 14.98100662231445 C 14.25535583496094 12.35004425048828 9.990118026733398 12.35004615783691 7.359848022460938 14.98100662231445 L 0 22.34085655212402 L 0 6.734857559204102 C 0.00444793701171875 3.01713752746582 3.017139434814453 0.004446029663085938 6.734848022460938 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "picture-2",
    "data-name": "picture",
    transform: "translate(119.597 178.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9819-2",
    "data-name": "Trac\\xE9 9819",
    d: "M11.437,12.561a3.085,3.085,0,0,0-4.365,0L.038,19.6a5.133,5.133,0,0,0,5.1,4.756h14.4a5.11,5.11,0,0,0,2.83-.856Z",
    transform: "translate(0.002 0.332)",
    fill: "#717171"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32-2",
    "data-name": "Ellipse 32",
    cx: 2.674,
    cy: 2.674,
    r: 2.674,
    transform: "translate(15.839 4.114)",
    fill: "#717171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Soustraction_3",
    "data-name": "Soustraction 3",
    d: "M22.37,20.916l0,0-9.476-9.476a5.142,5.142,0,0,0-7.272,0L0,17.058V5.142A5.157,5.157,0,0,1,5.142,0h14.4A5.122,5.122,0,0,1,22.37.851V3.775A3.174,3.174,0,0,0,19.541,2H5.145A3.156,3.156,0,0,0,2,5.142v7.094l2.21-2.209a7.137,7.137,0,0,1,10.1,0L22.37,18.09v2.825Z",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Soustraction_4",
    "data-name": "Soustraction 4",
    d: "M16.568,24.653H2.15A5.107,5.107,0,0,1,0,24.177V16.951l4.085-4.074a3.1,3.1,0,0,1,4.371,0L19.4,23.8A5.1,5.1,0,0,1,16.568,24.653Zm4.292-2.307h0L9.911,11.425a5.157,5.157,0,0,0-7.282,0L0,14.047V11.224l1.213-1.21a7.167,7.167,0,0,1,10.113,0l8.393,8.371V5.137A3.154,3.154,0,0,0,16.568,2H2.152A3.141,3.141,0,0,0,0,2.848V.47A5.126,5.126,0,0,1,2.15,0H16.568a5.159,5.159,0,0,1,5.151,5.136V19.517a5.07,5.07,0,0,1-.858,2.828ZM15.539,9.451a2.671,2.671,0,1,1,2.677-2.67A2.677,2.677,0,0,1,15.539,9.451Z",
    transform: "translate(183.878 178.641)",
    fill: "#717171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ligne_33",
    "data-name": "Ligne 33",
    d: "M84.4,1.564H.6A1.069,1.069,0,0,1-.5.532,1.069,1.069,0,0,1,.6-.5H84.4A1.069,1.069,0,0,1,85.5.532,1.069,1.069,0,0,1,84.4,1.564Z",
    transform: "translate(120.097 171.468)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ligne_33-2",
    "data-name": "Ligne 33",
    d: "M84.4,1.564H.6A1.069,1.069,0,0,1-.5.532,1.069,1.069,0,0,1,.6-.5H84.4A1.069,1.069,0,0,1,85.5.532,1.069,1.069,0,0,1,84.4,1.564Z",
    transform: "translate(120.097 209.403)",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider);
export default __webpack_public_path__ + "static/media/slider.40d61b7daf05bb696fb328fbc3ca4325.svg";
export { ForwardRef as ReactComponent };